// Merge by timestamp, retaining live/current values on overlapping pages.
export function mergeHistory(earlier = [], current = []) {
    const validEarlier = Array.isArray(earlier) ? earlier : [];
    const validCurrent = Array.isArray(current) ? current : [];
    const first = validCurrent[0]?.[0] ?? Infinity;
    return [...new Map([...validEarlier.filter(row => Array.isArray(row) && Number.isFinite(row[0]) && row[0] < first), ...validCurrent.filter(row => Array.isArray(row) && Number.isFinite(row[0]))].map(row => [row[0], row])).values()].sort((a, b) => a[0] - b[0]);
}
export function nearHistoryStart(bars = [], range = []) {
    if (!Array.isArray(bars) || !bars.length || !Array.isArray(range) || !Number.isFinite(range[0])) return false;
    const thresholdBar = bars[Math.min(100, bars.length - 1)];
    return thresholdBar?.[0] !== undefined && range[0] <= thresholdBar[0];
}
